import { ClientDealTableRow, DealTableRow } from "store/types";

const assignIdsToRows = (parentId: string, rows: DealTableRow[]): void => {
  rows
    .forEach((row, index) => {
      const clientRow = row as ClientDealTableRow;
      clientRow.id = parentId + "-" + index;
      if (clientRow.children) {
        assignIdsToRows(clientRow.id, clientRow.children);
      }
    });
};

export default assignIdsToRows;
